import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import DescriptionTable from './DescriptionTable';
import TimelineOverview from './TimelineOverview';
import RoundSpecialDetails from './RoundSpecialDetails';
import { getRoundSpecialDetails, getRoundSpecialsCornerTimeline, getRoundSpecialsTimeline } from '../../selectors/roundSpecials';
import { aGetRoundSpecialDetailsAction } from '../../reducers/roundSpecials';
import { getLeaguesMemoized } from '../../selectors/common';
import RoundCornerDetails from './RoundCornerDetails';

function groupMatchesByMinute(matches, teams, getScoreFields) {
  const teamMap = teams.reduce((acc, team) => {
    acc[team.id] = team.name;
    return acc;
  }, {});

  const groupedMatches = matches.reduce((acc, match) => {
    const { matchMinute } = match;

    if (!acc[matchMinute]) {
      acc[matchMinute] = { matchMinute, matches: [] };
    }

    const detailsForMinute = acc[matchMinute];
    detailsForMinute.matches.push({ ...match, homeTeam: teamMap[match.homeTeamId], awayTeam: teamMap[match.awayTeamId] });
    Object.assign(detailsForMinute, getScoreFields(match));
    return acc;
  }, {});

  return Object.values(groupedMatches).sort((a, b) => a.matchMinute - b.matchMinute);
}

function groupMatchesByMinuteGoals(matches, teams) {
  return groupMatchesByMinute(matches, teams, (match) => ({
    totalHomeGoals: match.totalHomeScore,
    totalAwayGoals: match.totalAwayScore,
    totalScorePerMinute: match.totalScore,
  }));
}

function groupMatchesByMinuteCorners(matches, teams) {
  return groupMatchesByMinute(matches, teams, (match) => ({
    homeCornerScore: match.homeCornerScore,
    awayCornerScore: match.awayCornerScore,
    totalCornerScore: match.totalCornerScore,
  }));
}

const RoundSpecialsMatchTimeline = () => {
  const dispatch = useDispatch();
  const params = useParams();

  const details = useSelector(getRoundSpecialDetails);
  const roundTimeline = useSelector(getRoundSpecialsTimeline);
  const roundCornerTimeline = useSelector(getRoundSpecialsCornerTimeline);
  const leagues = useSelector(getLeaguesMemoized);

  const selectedLeague = leagues.find((league) => league.id === details?.leagueId);
  const groupedMatchesRound = groupMatchesByMinuteGoals(roundTimeline || [], selectedLeague?.teams || []);
  const groupedMatchesCorners = groupMatchesByMinuteCorners(roundCornerTimeline || [], selectedLeague?.teams || []);

  useEffect(function loadRoundSpecialTimeline() {
    if (params?.id) {
      dispatch(aGetRoundSpecialDetailsAction({ id: params.id }));
    }
  }, [dispatch, params?.id]);

  return (
    <>
      <DescriptionTable roundId={details?.roundId} publicRoundId={details?.roundPublicId} leagueName={selectedLeague?.name} seasonId={details?.seasonId} />
      <TimelineOverview roundTotalScore={details?.roundTotalScore} minutes={details?.roundMinute} statusId={details?.statusId} roundTotalCorners={details?.roundTotalCorners} />
      <RoundSpecialDetails matches={groupedMatchesRound} />
      <RoundCornerDetails matches={groupedMatchesCorners} />
    </>
  );
};

export default RoundSpecialsMatchTimeline;